import {
  PRODUCT_TYPE_EVO,
  PRODUCT_TYPE_NOVA
} from '../../dashboard/product-filter';

export const getHeartbeatProductIDs = productType => {
  switch (parseInt(productType)) {
    case PRODUCT_TYPE_EVO:
      return [PRODUCT_TYPE_EVO];
    case PRODUCT_TYPE_NOVA:
      return [PRODUCT_TYPE_NOVA];
    default:
      return [PRODUCT_TYPE_EVO, PRODUCT_TYPE_NOVA];
  }
};

export const filterOnlineMarkersByDevices = (onlineMarkers, devices) => {
  const deviceSerials = new Set(
    (devices || []).map(device => String(device.SerialNumber))
  );

  return (onlineMarkers || []).filter(marker =>
    deviceSerials.has(String(marker.serial_number))
  );
};
